<template>
	<div class="page">
		<div class="pubHead">
			<Head></Head>
		</div>
		<div class="successBox">
			<div class="fixation">
				<div class="In">
					<div class="successIcon">
						<img src="../../assets/cart/success.png" alt="">
					</div>
					<div class="successRight">
						<div class="title">
							您已付款成功!
						</div>
						<div class="info">
							您的订单号为：{{oid}}，您可在个人中心中查看订单详情。<br>
							<!-- 如遇到任何问题请拨打客服电话：0311-132-31245<br>
							客服工作时间上午8：00-下午6：00 -->
						</div>
					</div>
					<div class="button">
						<button class="check" @click="goDetail">查看订单状况</button>
						<button class="back" @click="goIndex">返回首页</button>
					</div>
				</div>
			</div>
		</div>
		<div class="pubFoot">
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'success',
		components:{
			Head,Foot
		},
		data(){
			return {
				oid:""
			}
		},
		methods:{
			goIndex(){
				this.$router.push({path:'/',query:{}})
			},
			goDetail(){
				this.$router.push({path:'/person/order',query:{mid:0}})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.oid = this.$route.query.oid
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.successBox{
		width: 100%;
		height: 100%;
		position: fixed;
		padding-top: 160px;
		padding-bottom: 300px;
		box-sizing: border-box;
	}
	.fixation{
		padding-top: 1%;
		box-sizing: border-box;
	}
	.In{
		width: 100%;
		height: 100%;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
		box-shadow: 3px 3px 3px #E3E3E3;
	}
	.successIcon{
		width: 100px;
		height: 100px;
		float: left;
		margin-top: 50px;
		margin-left: 30px;
	}
	.successIcon img{
		width: 70px;
		height: 70px;
		display: block;
		margin: 0 auto;
	}
	.successRight{
		width: 1000px;
		height: 150px;
		float: left;
		margin-top: 50px;
	}
	.title{
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 36px;
		font-weight: 600;
		padding-left: 20px;
		box-sizing: border-box;
		color: #333333;
	}
	.info{
		width: 100%;
		height: 72px;
		line-height: 24px;
		font-size: 14px;
		padding-left: 20px;
		box-sizing: border-box;
		color: #838383;
		box-sizing: border-box;
	}
	.button{
		width: 100%;
		height: 60px;
		padding-left: 110px;
		box-sizing: border-box;
		margin-top: 30px;
		float: left;
	}
	.check{
		width: 150px;
		height: 40px;
		border-radius: 3px;
		border: none;
		background: #4c95ef;
		color: #FFFFFF;
	}
	.back{
		width: 150px;
		height: 40px;
		border-radius: 3px;
		border: 1px solid #4c95ef;
		background: none;
		margin-left: 30px;
		color: #4c95ef;
	}
	.pubHead,.pubFoot{
		width: 100%;
		position: fixed;
		left: 0px;
		z-index: 10;
	}
	.pubHead{
		top: 0px;
		background: #FFFFFF;
	}
	.pubFoot{
		bottom: 0px;
	}
</style>
